var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClaim(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.23026 0.0508414C9.40274 -0.0169471 9.5972 -0.0169471 9.76968 0.0508414L12.5502 1.14352C12.904 1.28257 13.0702 1.66299 12.9211 1.99323C12.7722 2.32346 12.3645 2.47844 12.0107 2.3394L9.50001 1.35272L1.40755 4.53292L1.56009 8.37713C1.72773 12.6016 4.56953 16.3289 8.79086 17.8611L9.50001 18.1185L10.2091 17.8611C14.4305 16.3289 17.2723 12.6016 17.4399 8.37713L17.5924 4.53292L15.7181 3.79631C15.3642 3.65727 15.1981 3.27684 15.3472 2.94661C15.4961 2.61638 15.9038 2.46139 16.2575 2.60043L18.5746 3.511C18.8411 3.6157 19.0102 3.86334 18.9995 4.13296L18.8292 8.42512C18.6411 13.1668 15.4513 17.3507 10.713 19.0704L9.75188 19.4192C9.58993 19.4781 9.4101 19.4781 9.24806 19.4192L8.28695 19.0704C3.54874 17.3507 0.358973 13.1668 0.170807 8.42512L0.000479045 4.13296C-0.0102151 3.86334 0.158967 3.6157 0.42538 3.511L9.23026 0.0508414Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9506 6.55839C13.6905 6.33698 13.2742 6.33698 13.0141 6.55839L7.94386 10.8755L5.98903 9.21107C5.72899 8.98966 5.31258 8.98966 5.05254 9.21107C4.78457 9.43925 4.78457 9.81496 5.05254 10.0431L7.47563 12.1063C7.73567 12.3277 8.15205 12.3277 8.41209 12.1063L13.9506 7.39048C14.2186 7.16231 14.2186 6.78657 13.9506 6.55839Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaim);
export default __webpack_public_path__ + "static/media/Claim.3034725d49a88088fc874864ef5f402d.svg";
export { ForwardRef as ReactComponent };